/**
 * redux/hooks.ts — pre-typed `useAppDispatch` + `useAppSelector`.
 *
 * Use these everywhere in components instead of the bare hooks from
 * react-redux so TypeScript knows the dispatch + state types without
 * re-importing them at every call site.
 */

import { useDispatch, useSelector, type TypedUseSelectorHook } from 'react-redux';
import type { AppDispatch, RootState } from './store';

export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
